import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
// @ts-ignore
import { Rule } from '../_proto/duel_pb'
import { useQuestMaster } from './useQuestMaster'

export const useFrontierGateStore = defineStore('frontierGateStore', () => {
  // state
  const fgCloseResult = ref<any>([])
  const currentFgData = ref<any>([])

  // getters
  const getFgResult = computed(() => fgCloseResult.value)
  const getCurrentFgData = computed(() => [...currentFgData.value])

  // actions
  async function saveFgResult(result) {
    fgCloseResult.value = result
  }

  async function fetchCurrentFrontierGate() {
    const currentIds = await this.$nuxt.$questsService.getCurrentExtraNode()
    let data: any = []
    if (currentIds.length) {
      let currentDatas = await this.$nuxt.$questsService.getFgInfos(currentIds)
      currentDatas.forEach(x => {
        let master = useQuestMaster().getFgMaster(x.fgType)
        x.class = master.class
        x.image = master.image
        x.name = master.name
        x.partyLv = master.partyLv
        const map = new Map(x.rulesMap)
        this.rules = {}
        this.rules.isHpRecoveryChangeParamRecovery = map.get(Rule.HP_RECOVERY_CHANGE_PARAM_RECOVERY)
        this.rules.isIntDamageChangeIntDebuff = map.get(Rule.INT_DAMAGE_CHANGE_INT_DEBUFF)
        this.rules.isNoSameHero = map.get(Rule.NO_SAME_HERO)
        this.rules.isNoSameRarity = map.get(Rule.NO_SAME_RARITY)
        this.rules.isNoWp = map.get(Rule.NO_WP)
        this.rules.isPrimeOnly = map.get(Rule.PRIME_ONLY)
        this.rules.isRegulation0619 = map.get(Rule.REGULATION_06_19)
        this.rules.isNoSameExtension = map.get(Rule.NO_SAME_EXTENSION)
        this.rules.isNeedPhonehash = map.get(Rule.NEED_PHONEHASH)
        x.rules = this.rules
        data.push(x)
      })
    }
    currentFgData.value = data
  }

  return {
    fgCloseResult,
    currentFgData,
    getFgResult,
    saveFgResult,
    getCurrentFgData,
    fetchCurrentFrontierGate,
  }
})
